import React from "react";
import { CustomSelect } from "../../../UI/Select";
import useGetProductApi from "../../../Global/Api/Schedule/getProductApi";
import { useDispatch, useSelector } from "react-redux";
import {
  changeSchedule,
  removeLineItems,
  setQuantity,
} from "../../../Store/Slice/scheduleSlice";
import useSetLineItems from "../../../Global/Api/Schedule/setLineItems";
import useGetTypeOfServicesApi from "../../../Global/Api/Schedule/getTypeOfServicesApi";
import CountInput from "../../../UI/CountInput";
import useFormatTime from "../../../Global/Api/Shared/useFormatTime";
import {useParams} from "react-router-dom";

export default function RowItem({ item }) {
    const {title: jobTitle} = useParams();
    const isRescheduleMode = Boolean(jobTitle);
  const dispatch = useDispatch();
  const productOptions = useGetProductApi()?.options;
  const setLineItems = useSetLineItems();
  const getTypeOfServiceApi = useGetTypeOfServicesApi();
  const { formatTime } = useFormatTime();
  const lineItems = useSelector(
    (state) => state.rootReducer.scheduleSlice.line_items
  );
  const accountData = useSelector(
    (state) => state.rootReducer.techsbookSlice.userData
  );

  const handleSelected = (type, id, selected) => {
    dispatch(
      changeSchedule({
        id,
        [type]: selected,
        data: { ...selected },
        type,
      })
    );
  };

  const showPrice = (item) => {
    if (+item?.price % 1 === 0) {
      return item?.price;
    } else {
      return parseFloat(item?.price)?.toFixed(2);
    }
  }

  return (
    <div key={item?.id} className="lineitems__row row_s">
      <div className="lineitems__td">
        <CustomSelect
          selected={item?.product}
          options={productOptions}
          handleSelect={(selected) => {
            handleSelected("product", item?.id, selected);
            setLineItems.clear();
            getTypeOfServiceApi.get({
              id: item.id,
              product_id: selected?.value,
            });
          }}
          placeholder={"Select product"}
          disabled={isRescheduleMode}
          searchable={true}
        />
      </div>
      <div className="lineitems__td img">
        {item?.product?.image && (
          <img src={item?.product?.image} alt="product image" />
        )}
      </div>
      <div className="lineitems__tr">
        <CustomSelect
          selected={item?.type_of_service}
          options={item?.type_of_services}
          placeholder={"Select service"}
          disabled={isRescheduleMode}
          handleSelect={(selected) =>
            handleSelected("type_of_service", item?.id, selected)
          }
        />
      </div>
      <div className="lineitems__tr">
        <CountInput
          disabled={!item?.type_of_service?.id || isRescheduleMode}
          initialCount={item?.quantity}
          minCount={1}
          handleChange={(count) => {
            dispatch(setQuantity({ id: item.id, quantity: count }));
          }}
        />
      </div>
      <div className="lineitems__tr">{accountData?.country_currency_sign} {showPrice(item) ?? 0}</div>
      <div className="lineitems__tr">
        {formatTime(item?.approximate_time) ?? "00:00"} hrs
      </div>
      <div className="lineitems__tr">
        {lineItems?.length > 1 && !isRescheduleMode ? (
          <img
            className="lineitems__remove"
            src="/assets/icons/close.svg"
            alt="close"
            onClick={() => {
              dispatch(removeLineItems(item?.id));
            }}
          />
        ) : null}
      </div>
    </div>
  );
}
